import { Directive, Input, HostListener } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[appAnalytics]',
})
export class AppAnalyticsDirective {
    @Input('appAnalytics') triggerOn: string;
    @Input() eventCategory: string;
    @Input() eventAction: string;
    @Input() eventLabel: string;
    @Input() eventType: string;

    @HostListener('click')
    onClick() {
        if (this.triggerOn === 'click') {
            this.push();
        }
    }

    @HostListener('focusout')
    onFocusOut() {
        if (this.triggerOn === 'focusout') {
            this.push();
        }
    }

    private push() {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
            event: 'Event',
            category: this.eventCategory,
            action: this.eventAction,
            label: this.eventLabel,
            ...(this.eventType && { eventType: this.eventType }),
        });
    }
}
